import { StandardEvents } from '@shopify/events';
class ShubFaceSummary extends HTMLElement {
 connectedCallback() {
  this.controller = new AbortController();
  const section = this.closest('.shopify-section');
  section?.addEventListener(StandardEvents.productSelect, (event) => {
   const active = this.request = event.promise;
   active?.then((result) => {
    if (this.request !== active || !this.isConnected) return;
    const replacement = result.detail?.html?.querySelector('shub-face-summary[data-product-id="' + this.dataset.productId + '"]');
    if (replacement) this.innerHTML = replacement.innerHTML;
   }).catch(() => {});
  }, {signal:this.controller.signal});
 }
 disconnectedCallback() { this.controller?.abort(); }
}
if (!customElements.get('shub-face-summary')) customElements.define('shub-face-summary', ShubFaceSummary);
